import React from 'react'

export const CheckingView = () => (
  <div className="ld-checking">
    <div className="spinner-border text-primary" role="status">
      <span className="visually-hidden">Loading…</span>
    </div>
    <div className="ld-checking__label">Looking up device…</div>
  </div>
)
